import React from 'react';
import '@atlaskit/css-reset';
import ReactDOM from 'react-dom';
import RoutableApp from './ui/routable-app'
import QueryParams from './services/query-params'
import * as serviceWorker from './serviceWorker';

const root = document.getElementById('root');
ReactDOM.render(<RoutableApp {...QueryParams}/>, root);
serviceWorker.unregister();
